var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summer-camp-page"},[_c('SummerCampHero',{on:{"schedule":_vm.handleSchedule}}),_vm._v(" "),_c('SummerCampWhyChoose'),_vm._v(" "),_c('SummerCampAboutProgram'),_vm._v(" "),_c('SummerCampSchedule'),_vm._v(" "),_c('SummerCampLocation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }